<template>
    <v-container fluid>
        <div>
            <v-select :items="langs" label="请选择需要设置的语言" item-text="name" v-model="lang" item-value="id"></v-select>
        </div>
        <template v-if="fields && fields.length > 0">
            <div v-for="f in fields" :key="f.label">
                <div>
                    <v-textarea v-if="f.textarea" :label="f.label" v-model="f.val"></v-textarea>
                    <v-text-field v-else :label="f.label" v-model="f.val"></v-text-field>
                </div>
                <div v-if="f.others">
                    <v-text-field :label="f.others.label" v-model="f.othersVal"></v-text-field>
                </div>
            </div>
            <div style="text-align: center;"><v-btn @click="save" color="primary">保存</v-btn></div>
        </template>
    </v-container>
</template>
<script>
export default {
    name: 'lang-settings',
    props: {
        /*fields:[{category, categoryId, type, targetId, label, textarea}] */
        cfg: Object
    },
    data() {
        return {
            langs: [],
            lang: null,
            fields: null
        }
    },
    watch: {
        lang() {
            this.initForm();
        }
    },
    methods: {
        init() {
            let self = this;
            //获取除中文以外支持的语言
            self.$axios.get('/home/admin/sys/lang/label/langs').then(r => {
                self.langs = r.data.message;
            });
        },
        initForm() {
            let self = this, cfg = self.cfg;
            if (!self.lang || !cfg || !cfg.fields || cfg.fields.length <= 0) {
                return;
            }

            let fields = cfg.fields;
            let gets = [], tmpFields = [];
            for (let f of fields) {
                tmpFields.push(f);
                gets.push(self.$axios.get(`/home/admin/sys/lang/label/get/by/target/${self.lang}/${f.category}/${f.type}/${f.categoryId}/${f.targetId}`));
            }
            self.$axios.all(gets).then(self.$axios.spread(function () {
                for (let i = 0; i < arguments.length; i++) {
                    let data = arguments[i].data;
                    if (data && data.status == 'ok' && data.message) {
                        tmpFields[i].val = data.message.rawVal;
                        tmpFields[i].othersVal = data.message.others;
                    }
                }
                self.fields = tmpFields;
            }));
        },
        save() {
            let self = this, fields = self.fields, lang = self.lang;
            if (!lang || !fields || fields.length <= 0) {
                return;
            }
            let posts = [];
            for (let f of fields) {
                posts.push(self.$axios.post(`/home/admin/sys/lang/label/add/${lang}/${f.category}/${f.type}/${f.categoryId}/${f.targetId}`, self.$qs.stringify({ val: f.val, others: f.othersVal })));
            }

            self.$axios.all(posts).then(self.$axios.spread(function () {
                self.$status('保存成功～', 'success');
                self.$dialog.close();
            }));
        }
    },
    mounted() {
        this.init();
    }
}
</script>